export const API_HOST = 'https://staging.chefami.com';
export const environment = {
  production: false,
  imagePath: '/assets/img/',
  recipeImagePath: API_HOST + '/img/recipe/',
  imgPath: API_HOST + '/img/',
  locationsImagePath: API_HOST + '/img/locations/',
  googleApiKey: 'AIzaSyDrF6KP4NQj3XttjIh7YetF_oEvP87pqWw',
  login: API_HOST + '/api/login',
  logout: API_HOST + '/api/logout',
  forgotPassword: API_HOST + '/api/forgot-password',
  getSiteData: API_HOST + '/api/fetch-site-data',
  getNewToken: API_HOST + '/api/get-new-token',
  getMyOrderList: API_HOST + '/api/my-order',
  getOrderDetail: API_HOST + '/api/order-detail',
  getAccountDetails: API_HOST + '/api/get-account-details',
  updatePaymentInformation: API_HOST + '/api/update-my-payment-information',
  updateEmailPasswordInfo: API_HOST + '/api/update-my-account-information',
  updateDeliveryInformation: API_HOST + '/api/update-my-delivery-information',
  updateUserAge: API_HOST + '/api/update-user-age',
  getAllPlanDetails: API_HOST + '/api/get-all-plans',
  updatePlan: API_HOST + '/api/update-my-plan',
  getScheduleDetails: API_HOST + '/api/get-schedule-details',
  getRecipesByDate: API_HOST + '/api/get-recipes',
  skipDelivery: API_HOST + '/api/skip-delivery',
  resumeDelivery: API_HOST + '/api/resume-delivery',
  customizeMeal: API_HOST + '/api/customize-meals',
  reactivateUser: API_HOST + '/api/change-subscription-status',
  getAllFreeMeals: API_HOST + '/api/get-user-free-boxes',
  sendFreeBox: API_HOST + '/api/send-free-box',
  sendFreeBoxReminder: API_HOST + '/api/send-free-box-reminder',
  deleteFreeBox: API_HOST + '/api/delete-free-box',
  getWalletsAndDiscount: API_HOST + '/api/get-wallet-and-discounts',
  addGiftCardToNextDelivery: API_HOST + '/api/add-gift-card',
  getReferralDetails: API_HOST + '/api/get-referral-details',
  applySecondDeliveryDiscount: API_HOST + '/api/add-second-delivery-discount',
  updateFirstDelivery: API_HOST + '/api/change-first-delivery',
  saveCheckoutSurvey: API_HOST + '/api/save-survery-after-checkout',
  updateUserPreference: API_HOST + '/api/update-user-preference',
  saveAnalytics: API_HOST + '/api/save-analytics',
  getMealsCount: API_HOST + '/api/get-meals-count',
  getUserFrequency: API_HOST + '/api/get-user-frequency',
  updateUserFrequency: API_HOST + '/api/update-user-frequency',
  checkCouponDiscount: API_HOST + '/api/check-appiled-coupon-and-discount-on-next-delivery',
  applyCancellationDiscount: API_HOST + '/api/apply-forty-dollar-credit-coupon',
  cancelSubscription: API_HOST + '/api/cancel-user-subscription',
  dislikeFoodInformation: API_HOST + '/api/send-information',
  resetPassword: API_HOST + '/api/reset-password',
  universalReactivation: API_HOST + '/api/universal-reactivation',
  getOrderYearsList: API_HOST + '/api/get-orders-years-list',
  getRecipesRatings: API_HOST + '/api/get-recipes-ratings/',
  saveRatings: API_HOST + '/api/save-my-rating/',
  setUpToken: API_HOST + '/api/get-setup-token',
  cookieDomain: '.chefami.com',
  maintainence: API_HOST + '/maintenance.php'
};